module.exports = __webpack_public_path__ + "static/media/bloga.300ee0c3.jpeg";